export default [
  {
    path: "householdManagement",
    name: "householdManagement",
    component: () => import("@/views/defenseManagement/householdManagement.vue"),
    meta: {
      title: "住户管理"
    }
  },
  {
    path: "unitManagement",
    name: "unitManagement",
    component: () => import("@/views/defenseManagement/unitManagement.vue"),
    meta: {
      title: "单位管理"
    }
  },
  {
    path: "estateManagement",
    name: "estateManagement",
    component: () => import("@/views/defenseManagement/estateManagement.vue"),
    meta: {
      title: "物业管理"
    }
  },
  {
    path: "communityInformationConfiguration",
    name: "communityInformationConfiguration",
    component: () => import("@/views/defenseManagement/communityInformationConfiguration.vue"),
    meta: {
      title: "小区管理"
    }
  },
  {
    path: "vehicleInformation",
    name: "vehicleInformation",
    component: () => import("@/views/defenseManagement/vehicleInformation.vue"),
    meta: {
      title: "车辆管理"
    }
  }
];